module.exports = __webpack_public_path__ + "img/Home21-Doctor.41a75bc7.jpg";